import { Meta, theme } from 'aimo-ui';
import React from 'react';
import { Pressable, StyleSheet, ViewProps } from 'react-native';
import Animated, { FadeInRight, FadeOutLeft } from 'react-native-reanimated';
import styled from 'styled-components/native';
import { CenterColumn } from 'styles/ContainerStyles';
import { isWeb } from 'utils/deviceUtils';

export const AnimatedTouchable = Animated.createAnimatedComponent(Pressable);

export const OngoingParkingHeaderStyles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingTop: 8,
    paddingBottom: 4,
    paddingHorizontal: 20,
    height: 73,
  },
  ongoingParkingSlide: {
    backgroundColor: theme.colors.gray300,
    height: 6,
    flexDirection: 'row',
    position: 'relative',
  },
});

export const Time = styled.Text`
  font-family: ${({ theme: t }) => t.fontFamily.bold};
  font-size: ${({ theme: t }) => t.normalising.fontPixel(56)}px;
  color: ${({ theme: t }) => t.colors.white};
`;

export const StyledMeta = styled(Meta)<{
  mt?: number;
  ml?: number;
  mb?: number;
}>`
  margin-top: ${({ mt }) => (mt ? mt + 'px' : '4px')};
  margin-left: ${({ ml }) => (ml ? ml + 'px' : '0px')};
  margin-bottom: ${({ mb }) => (mb ? mb + 'px' : '0px')};
  color: ${({ theme: t }) => t.colors.white};
  font-size: ${({ theme: t }) => t.normalising.fontPixel(16)}px;
  text-align: center;
`;

export const OngoingParkingHeaderWrapper = styled.View<{
  mr?: number;
  grow?: boolean;
}>`
  margin-right: ${({ mr }) => mr ?? 0}px;
  flex-grow: ${({ grow }) => (grow ? 1 : 0)};
  flex-shrink: 1;
`;

export const StatusContainer = styled.View`
  justify-content: center;
  align-items: center;
  margin: ${theme.normalising.heightPixel(40)}px 0px;
`;

export const HeaderContainer = styled(CenterColumn)`
  flex: 1;
`;

export const AnimatedFullContainer: React.FC<ViewProps> = ({ children }) => {
  return (
    <Animated.View
      entering={FadeInRight.duration(400)}
      exiting={isWeb ? undefined : FadeOutLeft.duration(400)}
      style={{ flex: 1 }}>
      {children}
    </Animated.View>
  );
};
